// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table__header__style.ty2 tbody tr:last-child td[data-v-09c88e41]{border-bottom:1px solid #eee!important}", ""]);
// Exports
module.exports = exports;
